import { IHttpApi } from '@cian/http-api/';

import { createRequestPayloadForPersonal } from './createRequestPayload';
import {
  fetchCreatePersonalMessage,
  TCreatePersonalMessageResponse,
} from '../../../repositories/demand/v2/create-personal-message';
import { TMappedAnswersState } from '../types';
import { selectPage } from '../../../selectors/selectPage';
import { IApplicationState } from '../../../types/redux';
import { selectIsWebview } from '../../../selectors/selectIsWebview';

interface IParams {
  httpApi: IHttpApi;
  mappedAnswersState: TMappedAnswersState;
  state: IApplicationState;
}

export const createPersonalRequest = async (params: IParams): Promise<TCreatePersonalMessageResponse> => {
  const { httpApi, mappedAnswersState, state } = params;
  const isWebview = selectIsWebview(state);
  const { platform, queryParams } = selectPage(state);
  const parameters = createRequestPayloadForPersonal({ platform, isWebview, mappedAnswersState, queryParams });

  return fetchCreatePersonalMessage({
    httpApi,
    parameters,
  });
};
